import React from 'react';

import styled from 'styled-components';

interface MembershipFeatureItemProps {
  iconSrc: string;
  alt: string;
}

const ItemText = styled.label`
  ${({ theme }) => theme.paragraph.variants.paragraph3.textStyles}
  color: ${({ theme }) => theme.colors.white};
  margin-left: 16px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;

  flex-grow: 1;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const MembershipFeatureItem = ({
  iconSrc,
  alt,
  children,
}: React.PropsWithChildren<MembershipFeatureItemProps>) => {
  return (
    <ListItem>
      <IconContainer>
        <img src={iconSrc} alt={alt} />
      </IconContainer>
      <ItemText>{children}</ItemText>
    </ListItem>
  );
};
